import React, { useEffect } from 'react'
import { HeaderProps } from './types'
import { useOnboarding } from './OnboardingContext'

const Header: React.FC<{}> = ({
}) => {

    const {
        formdata,
        currentPage = 0,
        themeManager,
        onboardingGetPropsFunctions
    } = useOnboarding();

    return (
        <>
            {formdata.length > 0 &&
                !!onboardingGetPropsFunctions.getHeaders() &&
                // ((Array.isArray(headersArray) && !!headersArray) ? (
                ((Array.isArray(onboardingGetPropsFunctions.getHeaders()) && !!onboardingGetPropsFunctions.getHeaders()) ? (
                    <div className="q-onb-main-heading"
                        style={themeManager.getTopBarStyles().topbarStyle}
                    >
                        <div
                            className="q-onb-main-h3"
                            style={themeManager.getTopBarStyles().headingStyle}
                        >
                            {Array.isArray(onboardingGetPropsFunctions.getHeaders()) && onboardingGetPropsFunctions.getHeaders()[currentPage]?.heading}
                        </div>
                        <div
                            className="q-onb-main-h4"
                            style={themeManager.getTopBarStyles().subHeadingStyle}
                        >
                            {onboardingGetPropsFunctions.getHeaders()[currentPage]?.subHeading}
                        </div>
                    </div>
                ) : Array.isArray(onboardingGetPropsFunctions.getHeaders()) && !!onboardingGetPropsFunctions.getHeaders()[currentPage] ? (
                    <div className="q-onb-main-heading"
                        style={themeManager.getTopBarStyles().topbarStyle}
                    >
                        <div
                            className="q-onb-main-h3"
                            style={themeManager.getTopBarStyles().headingStyle}
                        >
                            {onboardingGetPropsFunctions.getHeaders()[currentPage]?.heading}
                        </div>
                        <div
                            className="q-onb-main-h4"
                            style={themeManager.getTopBarStyles().subHeadingStyle}
                        >
                            {onboardingGetPropsFunctions.getHeaders()[currentPage]?.subHeading}
                        </div>
                    </div>
                ) : (
                    <div className="q-onb-main-heading"
                        style={themeManager.getTopBarStyles().topbarStyle}
                    >
                        <div
                            className="q-onb-main-h3"
                            style={themeManager.getTopBarStyles().headingStyle}
                        >
                            {Array.isArray(onboardingGetPropsFunctions.getHeaders()) && onboardingGetPropsFunctions.getHeaders()[currentPage]?.heading}
                        </div>
                        <div
                            className="q-onb-main-h4"
                            style={themeManager.getTopBarStyles().subHeadingStyle}
                        >
                            {Array.isArray(onboardingGetPropsFunctions.getHeaders()) && onboardingGetPropsFunctions.getHeaders()[currentPage]?.subHeading}
                        </div>
                    </div>
                ))}
        </>
    )
}

export default Header